export interface IComment {
    userId: number;
    userName:string;
    comment:string;
    date:Date;
}